import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";
import { t } from '../../i18n';

export class PropertyBelonging extends Component {

    render() {
        const title = t('menu.support.p10');
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'propertyBelonging'}
            title={ title }
            exportTitle={`<h2>${title}</h2>`}
            exportFileName={'property_belonging.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (PropertyBelonging);
